import React from 'react';
import './PropertyCard.css';
import Cta from './cta'; 
import heartIcon from '../../assets/Heart.png';
import bedIcon from '../../assets/Bed.png';
import bathIcon from '../../assets/Bath.png';
import floorIcon from '../../assets/Floor.png';

const PropertyCard = ({ image, title, location, price, beds, baths, area }) => {
  return (
    <div className="property-card">
      <div className="card-top">
        <img src={image} alt={title} className="property-img" />
        <div className="heart-circle">
          <img src={heartIcon} alt="heart" />
        </div>
      </div>

      <div className="card-body">
        <h3 className="property-name">{title}</h3>
        <p className="property-loc">{location}</p>

        <div className="property-icons">
          <div className="icon-group">
            <img src={bedIcon} alt="beds" /> <span>{beds}</span>
          </div>
          <div className="icon-group">
            <img src={bathIcon} alt="baths" /> <span>{baths}</span>
          </div>
          <div className="icon-group">
            <img src={floorIcon} alt="area" /> <span>{area} sqm</span>
          </div>
        </div>

        <div className="card-footer-flex">
          <div className="price-block">
            <span className="price-label">Total Price</span>
            <span className="price-value">{price}</span>
          </div>
          <Cta title="View Details" stylee="card-btn" />
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;